import { gql, TypedDocumentNode } from '@common/hooks';
import {
  AddHoursOptionsQueryCgResponse,
  AddHoursOptionsQueryVariables,
  ManagerHourBlockErrorsPreviewQueryCgResponse,
  ManagerHourBlockErrorsPreviewQueryVariables,
} from '@common/graphql/schema';
import { HourBlockErrors } from '@timekeeping/graphql';

export const AddHoursFormOptions: TypedDocumentNode<
  AddHoursOptionsQueryCgResponse,
  AddHoursOptionsQueryVariables
> = gql`
  query AddHoursOptions($workerTimesheetId: ID!, $facilityId: ID) {
    worksTimekeepingAddHoursOptions(
      workerTimesheetId: $workerTimesheetId
      facilityId: $facilityId
    ) {
      facilities {
        id
        name
        timeZone
      }
      units {
        id
        name
        costCenter
      }
      hourTypes {
        id
        name
      }
      clockInRange {
        minimum
        maximum
      }
    }
  }
`;

export const ManagerHourBlockErrorsPreview: TypedDocumentNode<
  ManagerHourBlockErrorsPreviewQueryCgResponse,
  ManagerHourBlockErrorsPreviewQueryVariables
> = gql`
  query ManagerHourBlockErrorsPreview($input: WorksTimekeepingAddHoursInput!) {
    preview: worksTimekeepingManagerHoursErrorsPreview(input: $input) {
      preventsChanges
      errors {
        ...HourBlockErrors
      }
    }
  }
  ${HourBlockErrors}
`;
